var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-logo-container",
      class: { collapse: _vm.collapse },
    },
    [
      _c("transition", { attrs: { name: "sidebarLogoFade" } }, [
        _c("div", { staticClass: "flex" }, [
          _c(
            "div",
            {
              staticClass: "toggle-sidebar-like",
              attrs: { id: "toggle-sidebar-like" },
              on: { click: _vm.toggleSideBarLike },
            },
            [
              _vm.isLiked
                ? _c("svg-icon", { attrs: { "icon-class": "more" } })
                : _vm._e(),
              !_vm.isLiked
                ? _c("i", { staticClass: "el-icon-star-on" })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "sidebar-logo-img no-user-select flex-align-justify",
              on: { click: _vm.toHome },
            },
            [
              _c("img", {
                staticStyle: { width: "60px", height: "21px" },
                attrs: { src: _vm.$getPublicImage("logo.png") },
              }),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }